import { Component } from '@mycolorway/tao';
import $ from 'jquery';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-project-kanban-completed-todos', {
  mixins: [eventListenerMixin],

  properties: {
    scrollLoadUrl: String,
  },

  connected() {
    this.scrollLoadTrigger = this.querySelector('tr-scroll-load-trigger');
    this.listenTo(this.scrollLoadTrigger, {
      'tr-scroll-load-trigger:loading': this.loadMore.bind(this),
    });
  },

  disconnected() {
    this.stopListening();
  },

  loadMore() {
    const lastGroup = this.scrollLoadTrigger.previousElementSibling;
    if (!lastGroup) return;

    $.ajax({
      url: this.scrollLoadUrl,
      method: 'get',
      data: { till: lastGroup.dataset.till },
      dataType: 'script',
    });
  },

  appendGroups(groups) {
    const [firstGroup, ...restGroups] = $(groups);
    const lastGroup = this.scrollLoadTrigger.previousElementSibling;

    const firstGroupTitle = firstGroup.querySelector('.group-title').textContent;
    const lastGroupTitle = lastGroup.querySelector('.group-title').textContent;

    if (firstGroupTitle === lastGroupTitle) {
      lastGroup.querySelector('.group-content').insertAdjacentHTML(
        'beforeend',
        firstGroup.querySelector('.group-content').innerHTML,
      );
      restGroups.forEach((group) => {
        this.scrollLoadTrigger.insertAdjacentElement('beforebegin', group);
      });
    } else {
      this.scrollLoadTrigger.insertAdjacentHTML('beforebegin', groups);
    }
  },
});
